
import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"
import Edit from "@/components/SponsoredLinks/Edit.vue"

import { DataTableHeader } from "vuetify/types"
import { SponsoredLink } from "types/sponsoredLink"

@Component({ components: { Edit } })
export default class SponsoredLinks extends Vue {
  private loading = true
  private sponsoredLinks: SponsoredLink["data"][] = []

  get headers(): DataTableHeader[] {
    return [
      { text: "優先度", value: "priority" },
      { text: "タイトル", value: "title" },
      { text: "リンク", value: "link" },
      { text: "広告主", value: "advertiser" },
      { text: "サムネイル", value: "thumbnail", sortable: false },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.getSposoredLinks()
  }

  private getSposoredLinks() {
    api
      .getSponsoredLinks()
      .then((res) => {
        this.sponsoredLinks = res.data.sponsoredLinks
      })
      .catch(() => {
        this.$toasted.error("スポンサー広告一覧の取得に失敗しました")
      })
      .finally(() => {
        this.loading = false
      })
  }

  private updateSponsoredLink() {
    this.getSposoredLinks()
  }

  private open(id?: number) {
    if (id) {
      const refs = this.$refs[id] as InstanceType<typeof Edit>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<typeof Edit>
      newDialog.open()
    }
  }

  private existThumbnail(thumbnail: {
    filename: string
    url: string
  }): boolean {
    return thumbnail.filename !== null && thumbnail.url !== null
  }
}
